// src/utils/motion.js
// Master Animation System (GDSS / Framer Motion Standards)

export const transitions = {
  snap: { type: 'spring', damping: 24, stiffness: 320, mass: 0.8 },
  gentle: { type: 'spring', damping: 22, stiffness: 140, mass: 1 },
  bouncy: { type: 'spring', damping: 14, stiffness: 220, mass: 0.9 },
  smooth: { duration: 0.5, ease: [0.16, 1, 0.3, 1] },
  cinematic: { duration: 0.8, ease: [0.22, 1, 0.36, 1] },
};

export const revealStagger = {
  container: {
    hidden: { opacity: 0 },
    visible: (custom = {}) => ({
      opacity: 1,
      transition: {
        staggerChildren: custom.stagger || 0.12,
        delayChildren: custom.delay || 0.1,
      },
    }),
  },
  item: {
    hidden: { opacity: 0, y: 24, scale: 0.97 },
    visible: {
      opacity: 1,
      y: 0,
      scale: 1,
      transition: transitions.smooth,
    },
  },
};

export const fadeUp = {
  hidden: { opacity: 0, y: 28 },
  visible: (delay = 0) => ({
    opacity: 1,
    y: 0,
    transition: { ...transitions.smooth, delay },
  }),
};

export const scaleIn = {
  hidden: { opacity: 0, scale: 0.92 },
  visible: (delay = 0) => ({
    opacity: 1,
    scale: 1,
    transition: { ...transitions.bouncy, delay },
  }),
};

export const floatPhysics = {
  animate: {
    y: [-6, 6, -6],
    rotate: [-1, 1, -1],
    transition: {
      duration: 6,
      repeat: Infinity,
      ease: 'easeInOut',
    },
  },
};

export const pulseGlow = {
  animate: {
    opacity: [0.4, 0.8, 0.4],
    scale: [1, 1.04, 1],
    transition: {
      duration: 3,
      repeat: Infinity,
      ease: 'easeInOut',
    },
  },
};
